import React from 'react';
import { transformationRows } from '../data/comparisons';
export function Transformation() {
  return <section aria-labelledby="transformation-heading" className="w-full bg-white" data-id="element-248" data-mp="ijrc6wdvx5v0">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-249" data-mp="mluy6ey6jsuj">
        <h2 id="transformation-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-250" data-mp="rl7j2u5hqpuh">
          From starting over to just… continuing
        </h2>

        <div className="mt-10 overflow-hidden rounded-2xl border border-cream-dark" data-id="element-251" data-mp="11j5afqind2rb">
          <div className="grid grid-cols-2" data-id="element-252" data-mp="16a3pynvt9wti">
            <p className="px-5 py-3 bg-cream text-xs font-bold uppercase tracking-[0.12em] text-ink-muted" data-id="element-253" data-mp="16beuipx2z8lo">
              Before
            </p>
            <p className="px-5 py-3 bg-sage text-xs font-bold uppercase tracking-[0.12em] text-white" data-id="element-254" data-mp="1adjlti023t55">
              With Homeschool, Handled.
            </p>
          </div>

          {transformationRows.map(row => <div key={row.before} className="grid grid-cols-2 border-t border-cream-dark" data-id="element-255" data-mp="1c6jm93o31e1v">
              <p className="px-5 py-4 text-[14px] sm:text-[15px] leading-relaxed text-ink-muted" data-id="element-256" data-mp="1765qajzr9uk7">
                {row.before}
              </p>
              <p className="px-5 py-4 text-[14px] sm:text-[15px] leading-relaxed text-ink font-medium bg-sage-tint/60 border-l border-cream-dark" data-id="element-257" data-mp="y68u7xb1dtf4">
                {row.after}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}